import Vue from 'vue'

// Session-only demonstration. No remote commands or real work orders are sent.
export const powerDuty = Vue.observable({ step: 0, records: [] })
export const dutyStates = ['待排查', '处理中', '待复核', '已闭环']
export function advanceDuty () {
  if (powerDuty.step >= 3) return
  const descriptions = ['已核查 AA01 网关：供电正常，上报延迟；登记模拟网络检查。', '模拟采集恢复：连续三次上报成功，电压 0.4 kV；等待复核。', '模拟复核通过：测点恢复、供电连续，事项归档。']
  powerDuty.records.push({ time: new Date().toLocaleTimeString('zh-CN', { hour12: false }), text: descriptions[powerDuty.step] })
  powerDuty.step++
}
export function resetDuty () { powerDuty.step = 0; powerDuty.records.splice(0) }
export function closedPowerCount (projects) { return powerDuty.step === 3 && projects.some(p => p.id === '1000107') ? 1 : 0 }
